import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="text-[#EAECEF] space-y-8 max-w-4xl mx-auto">
      <section className="mb-12">
        <h1 className="text-3xl font-bold mb-4">Privacy Policy - DreamSync LucidTTS</h1>
        <p className="text-[#B0B4BB] mb-2">Last Updated: Feb 13, 2025</p>
        <p className="text-[#B0B4BB] leading-relaxed">
          This Privacy Policy explains how we collect, use, and protect your information.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">1. Information We Collect</h2>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Account information (email, name)</li>
          <li>Usage data and analytics</li>
          <li>Payment information</li>
          <li>Generated content data</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">2. How We Use Information</h2>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Provide and improve our services</li>
          <li>Process payments and transactions</li>
          <li>Send service updates and communications</li>
          <li>Analyze usage patterns and trends</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">3. Information Sharing</h2>
        <p className="text-[#B0B4BB] leading-relaxed">We share information with:</p>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Service providers and partners</li>
          <li>Legal authorities when required</li>
          <li>Third-party analytics services</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">4. Data Security</h2>
        <p className="text-[#B0B4BB] leading-relaxed">We implement security measures including:</p>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Encryption of sensitive data</li>
          <li>Regular security assessments</li>
          <li>Access controls and monitoring</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">5. User Rights</h2>
        <p className="text-[#B0B4BB] leading-relaxed">You have the right to:</p>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Access your personal data</li>
          <li>Request data correction</li>
          <li>Delete your account</li>
          <li>Export your data</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">6. Data Retention</h2>
        <p className="text-[#B0B4BB] leading-relaxed">
          We retain data as long as necessary for service provision or legal requirements.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">7. Cookies and Tracking</h2>
        <p className="text-[#B0B4BB] leading-relaxed">
          We use cookies to improve site functionality and user experience.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">8. Children's Privacy</h2>
        <p className="text-[#B0B4BB] leading-relaxed">
          Our services are not intended for users under 18 years old.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">9. International Data Transfers</h2>
        <p className="text-[#B0B4BB] leading-relaxed">
          Data may be transferred and processed in countries outside of India.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">10. Policy Updates</h2>
        <p className="text-[#B0B4BB] leading-relaxed">
          We may update this policy periodically. Continued use of our service implies acceptance of changes.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">11. Contact Information</h2>
        <p className="text-[#B0B4BB] leading-relaxed">For privacy-related queries, contact:</p>
        <p className="text-[#B0B4BB] leading-relaxed">Email: ram@dreamsync.co.in</p>
        <p className="text-[#B0B4BB] leading-relaxed">
          Address: 3-39, Katta Colony, Kadiyam Mandalam, Andhra Pradesh 533126
        </p>
      </section>

      <footer className="text-[#B0B4BB] italic mt-12 pt-4 border-t border-[#3A3D3E]">
        <p>By using DreamSync LucidTTS, you agree to this Privacy Policy.</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;